import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstance2a03ktg5l3ejl as Companion_getInstance } from '../../models/data.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../reactive/Action.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function onClick(_this__u8e3s4, label, icon, action) {
  label = label === VOID ? null : label;
  icon = icon === VOID ? null : icon;
  var tmp = label == null ? 'Press' : label;
  var tmp_0 = icon == null ? Companion_getInstance().tcg_1 : icon;
  _this__u8e3s4.obg(Action(tmp, tmp_0, VOID, VOID, VOID, VOID, onClick$slambda_0(action)));
}
function *_generator_invoke__zhh2q8($this, $this$Action, $completion) {
  var tmp = $this.td9_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var onClick$slambdaClass;
function onClick$slambda() {
  if (onClick$slambdaClass === VOID) {
    class $ {
      constructor($action) {
        this.td9_1 = $action;
      }
      yah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    onClick$slambdaClass = $;
  }
  return onClick$slambdaClass;
}
function onClick$slambda_0($action) {
  var i = new (onClick$slambda())($action);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  onClick as onClick25t27tv78ic5x,
};
//endregion

//# sourceMappingURL=Button.mjs.map
